module.exports = __webpack_public_path__ + "static/media/gabriel_m1.9f6e9fe0.gif";